import React from 'react';

import { styled } from '@mui/styles';
import { withStyles } from '@mui/styles';
import { spacing } from '@mui/system';
import {  Grid, Typography } from '@mui/material';
import MuiButton from '@mui/material/Button';
import CheckIcon from '@mui/icons-material/Check'

import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { importFile, importPackageReset} from 'admin/actions/packageActions';
import { ActionTypes as types } from 'admin/actions/actionTypes';
import { getAlertHide } from 'admin/actions/alertActions';
import { showConfirmWarning, hideError } from 'admin/actions/alertActions';
import { packageTheme } from './theme/packageTheme';


const Button = styled(MuiButton)(spacing);


class ImportHeader extends React.Component {

    constructor(props) {
        super(props);
        
    }
    componentDidMount() {
        this.onDiscardClick();
    }
    onDiscardClick = () => {
        hideError(this.props.dispatch);
        this.props.dispatch(importPackageReset());
    }

    onImportClick = () => {
       
        
        this.callImportAction();
        
    }
    
    callImportAction = () => {

        this.props.dispatch(importFile(this.props.import));
    }
    
    render() {
        return (
            <Grid container direction="row" justifyContent="space-between" spacing={0} xl={12}>
               
                <Grid item>
                    <Typography variant="h4">Import</Typography>
                </Grid>
                <Grid item >
                    <Grid container direction="row" justifyContent="space-between" spacing={1} >
                        <Grid item >
                            <Button
                                className={this.props.classes.customControlButton }
                                variant="defaultContained"
                                disableElevation
                                startIcon={""}
                                onClick={this.onDiscardClick}
                            >RESET</Button>
                        </Grid>
                        <Grid item >
                            <Button
                                className={this.props.classes.customControlButton}
                                color="primary"
                                variant="contained"
                                disableElevation
                                startIcon={<CheckIcon />}
                                onClick={this.onImportClick}
                            >IMPORT</Button>
                        </Grid> </Grid>
                </Grid>
            </Grid> 
        );
    }

}

function mapStateToProps(state) {
    let props = {
        import: state.packages.importPackage,
        alert: state.alert,
        actionType: state.packages.actionType,
        
    };
    return props;
};
 
export default withRouter(connect(mapStateToProps)(withStyles(packageTheme)(ImportHeader)));
